import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getServiceTypes() {
  const data = await apiGet('helper/serviceTypes/');
  useHelperStore().setServiceTypes(data);
}
